<template>
  <div class="sidebar-pinned">
    <Navbar/>

    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-icon-wrap">
          <i class="fe fe-wifi-off"></i>
        </div>
        <div>
          <h2 class="page-header-title">Offline Access</h2>
          <p class="page-header-subtitle">Access key features without an internet connection</p>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <div class="row">

          <!-- Profile Card -->
          <div class="col-md-6 mb-4">
            <div class="card info-card shadow-sm h-100">
              <div class="info-card-header">
                <i class="fe fe-user mr-2"></i> My Profile
              </div>
              <div class="card-body d-flex align-items-center" style="gap: 16px;">
                <div class="profile-avatar">
                  {{ initials }}
                </div>
                <div>
                  <h5 class="font-weight-bold mb-1">{{ user.firstname }} {{ user.lastname }}</h5>
                  <p class="text-muted mb-1 small">{{ user.email }}</p>
                  <p class="text-muted mb-0 small">{{ user.phone_number }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Add Enrollee (employee / shis only) -->
          <div class="col-md-6 mb-4" v-if="user.type == 'employee' || user.type == 'shis'">
            <div class="card info-card shadow-sm h-100">
              <div class="info-card-header">
                <i class="fe fe-user-plus mr-2"></i> Enrollment
              </div>
              <div class="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h5 class="font-weight-bold mb-1">Add Enrollee</h5>
                  <p class="text-muted mb-0 small">Enroll beneficiaries offline</p>
                </div>
                <router-link to="/add-client-offline" class="btn btn-submit px-4">
                  <i class="fe fe-plus mr-1"></i> Start
                </router-link>
              </div>
            </div>
          </div>

          <!-- View Enrollees (employee only) -->
          <div class="col-md-6 mb-4" v-if="user.type == 'employee'">
            <div class="card info-card shadow-sm h-100">
              <div class="info-card-header">
                <i class="fe fe-users mr-2"></i> Enrollees
              </div>
              <div class="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h5 class="font-weight-bold mb-1">View Enrollees</h5>
                  <p class="text-muted mb-0 small">Review beneficiaries saved offline</p>
                </div>
                <router-link to="/offline-sync" class="btn btn-submit px-4">
                  <i class="fe fe-arrow-right mr-1"></i> View
                </router-link>
              </div>
            </div>
          </div>

          <!-- Add Encounter (provider_employee only) -->
          <div class="col-md-6 mb-4" v-if="user.type == 'provider_employee'">
            <div class="card info-card shadow-sm h-100">
              <div class="info-card-header">
                <i class="fe fe-activity mr-2"></i> Encounters
              </div>
              <div class="card-body d-flex align-items-center justify-content-between">
                <div>
                  <h5 class="font-weight-bold mb-1">Add Encounter Offline</h5>
                  <p class="text-muted mb-0 small">Add encounter information offline</p>
                </div>
                <a href="/add-record-offline" class="btn btn-submit px-4">
                  <i class="fe fe-plus mr-1"></i> Start
                </a>
              </div>
            </div>
          </div>

        </div>

        <!-- Offline Records (provider_employee only) -->
        <div v-if="user.type == 'provider_employee'">
          <MyRecordsOffline/>
        </div>

      </div>

    </main>

    <div class="vld-parent">
      <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
import Navbar from "@/views/Navbar.vue";
import MyRecordsOffline from "@/views/ehr/MyRecordsOffline.vue";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
    MyRecordsOffline,
    Navbar,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      auth_user: "",
      user: null,
    };
  },
  computed: {
    initials() {
      if (!this.user) return '?';
      return ((this.user.firstname?.[0] || '') + (this.user.lastname?.[0] || '')).toUpperCase();
    },
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    //
  },
  created() {
    //
  },
};
</script>
<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  padding: 36px 0 56px;
  display: flex;
  align-items: center;
  gap: 18px;
  padding-left: calc((100% - 1140px) / 2 + 15px);
  padding-right: calc((100% - 1140px) / 2 + 15px);
}
.header-icon-wrap {
  background: rgba(255,255,255,0.15);
  border-radius: 14px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}
.page-header-title {
  font-size: 1.6rem;
  font-weight: 800;
  margin: 0 0 4px;
}
.page-header-subtitle {
  margin: 0;
  opacity: .82;
  font-size: .9rem;
}

.info-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.info-card-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  font-weight: 600;
  font-size: .85rem;
  padding: 10px 16px;
  letter-spacing: .02em;
}

.profile-avatar {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  font-weight: 700;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: opacity 0.15s;
}
.btn-submit:hover {
  opacity: .88;
  color: #fff;
}
</style>
